import axios from "axios"

const domains = {
	"": {
		env: "inte",
		apibase: "/",
	},
	"int.fe.magellan-alpro-raffle-2026-frontend.campaign-loyalty.com": {
		env: "inte",
		apibase: "/inte/",
	},

	"prod.fe.magellan-alpro-raffle-2026-frontend.campaign-loyalty.com": {
		env: "prod",
		apibase: "/",
	},

	"gratistesten.alpro.com": {
		env: "prod",
		apibase: "/",
	},
}

export const getEnvConfig = () => {
	return domains[window.location.host] || { apibase: "/inte/" }
}

export async function checkOrderCount() {
	const env = getEnvConfig()
	return await axios
		.get(env.apibase + "checkOrder.php?cv=" + Date.now())
		.then(res => {
			let digits = Array.from(String(res.data.ordersLeft))
			return digits.map(str => Number(str))
		})
		.catch(error => {
			console.error("Not able to get counter: %s", error?.response?.status ?? error)
			return [0, 0, 0, 0, 0]
		})
}
export async function getPromoLimit() {
	const env = getEnvConfig()
	return await axios
		.get(env.apibase + "checkLimit.php?cv=" + Date.now())
		.then(res => {
			return res.data.limitReached
		})
		.catch(error => {
			return error.response.status
		})
}
export async function getWeeklyLimit() {
	const env = getEnvConfig()
	return await axios
		.get(env.apibase + "checkWeeklyLimit.php?cv=" + Date.now())
		.then(res => {
			return res.data.weeklyOrdersLeft
		})
		.catch(error => {
			return error.response.status
		})
}

export async function getWeeklyCount() {
	const env = getEnvConfig()
	return await axios
		.get(env.apibase + "checkWeeklyLimit.php?cv=" + Date.now())
		.then(res => {
			let digits = Array.from(String(res.data.ordersLeft))
			return digits.map(str => Number(str))
		})
		.catch(error => {
			console.error("Not able to get counter: %s", error?.response?.status ?? error)
			return [0, 0, 0, 0, 0]
		})
}
